import { render, staticRenderFns } from "./crossGroupDeliveryOrder.vue?vue&type=template&id=1957a620&scoped=true&"
import script from "./crossGroupDeliveryOrder.vue?vue&type=script&lang=js&"
export * from "./crossGroupDeliveryOrder.vue?vue&type=script&lang=js&"
import style0 from "./crossGroupDeliveryOrder.vue?vue&type=style&index=0&id=1957a620&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1957a620",
  null
  
)

export default component.exports